"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleTypes = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var SearchResultsMobile_v2_1 = __importDefault(require("./SearchResultsMobile_v2"));

var SearchResultsDesktop_v2_1 = __importDefault(require("./SearchResultsDesktop_v2"));

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var ArticleTypes;

(function (ArticleTypes) {
  ArticleTypes["theGauge"] = "blog";
  ArticleTypes["location"] = "location";
})(ArticleTypes || (exports.ArticleTypes = ArticleTypes = {}));

var SearchResults_v2 = function SearchResults_v2() {
  var _ref = (0, SearchResultsContext_v2_1.useSearchResults)(),
      isMobile = _ref.isMobile;

  return isMobile ? (0, jsx_runtime_1.jsx)(SearchResultsMobile_v2_1.default, {}) : (0, jsx_runtime_1.jsx)(SearchResultsDesktop_v2_1.default, {});
};

exports.default = SearchResults_v2;